module.exports = __webpack_public_path__ + "img/icon-project-gear.af15336d.svg";